import { addCommas, fixDecimalPlace, Item, ItemName, Locale, Numeric } from '@ps-smart-cp/ppfw-client';

function addCommasForCurrency(str: string, decimalPlaces: number) {
  const numStr = fixDecimalPlace(str, decimalPlaces);
  return addCommas(numStr);
}

function setDecimalPlaceToItemConfig<K extends string, I extends Record<K, Item>>(
  propArray: K[],
  items: I,
  decimalPlaces: number,
): I {
  propArray.forEach((prop) => {
    if (items[prop].attribute instanceof Numeric) {
      items[prop] = Item.of(
        ItemName.of([Locale.ja, items[prop].displayName.get(Locale.ja) ?? '']),
        items[prop].attribute.replaceDecimalPlaces(decimalPlaces),
      ) as unknown as I[K];
    }
  });
  return items;
}

export { addCommasForCurrency, setDecimalPlaceToItemConfig };
